module.exports = __webpack_public_path__ + "media/src/application/media/rooms/Media2-79e783f5043978655e2970d2bb32bca1.png";